import { isProduction, isStaging } from '../constants/staticData';
export const BASE_URL = isProduction ? 'https://api.carcility.com'
 : isStaging ? 'https://api-server-stage.carcility.com' : 'https://api-server-test.carcility.com';
/* Auth APIs */
export const SIGNUP = BASE_URL + '/auth/signup';
export const SIGNIN = BASE_URL + '/auth/login';
export const SOCIAL_AUTH = BASE_URL + '/auth/socialsignin';
export const FORGOT_PASSWORD = BASE_URL + '/auth/forgot-password';
export const VERIFY_OTP = BASE_URL + '/api/users/verifyotp/';
export const VERIFY_EMAIL = BASE_URL + '/auth/verifyemail';
export const REQUEST_OTP = BASE_URL + '/api/users/otp';
export const RESET_PASSWORD = BASE_URL + '/auth/reset-password';
export const LOGOUT = BASE_URL + '/api/users/logout';
export const CURRENT_USER_DETAILS = BASE_URL + '/api/users/me';
export const CONTACT_US = BASE_URL + '/auth/contactus';
export const GET_ACCOUNT_STATUS = BASE_URL + '/api/users/accountstatus';
export const CHANGE_BOARDING_STATUS = BASE_URL + '/api/users/changeboardingstatus';
/* User Profile APIs */
export const BUSINESS_PROFILE_REGISTRATION = BASE_URL + '/api/vendor/create';
export const GARAGE_PROFILE_DETAILS = BASE_URL + '/api/vendor/manageprofile';
export const GARAGE_IMAGES = BASE_URL + '/api/vendor/uploadimages';
export const GET_FACILITIES_MASTER = BASE_URL + '/api/vendor/facilities';
export const GET_GARAGE_PROFILE = BASE_URL + '/api/vendor/profiledetail';
export const DELETE_GARAGE_IMAGES = BASE_URL + '/api/vendor/image/';
export const GET_PARENT_SERVICES = BASE_URL + '/api/services';
export const GET_GARAGE_SERVICES = BASE_URL + '/api/vendor/services';
export const GET_ALL_MANUFACTURERS = BASE_URL + '/api/cars/manufacturers';
export const GET_SUPPORTED_MANUFACTURERS = BASE_URL + '/api/vendor/supportedMFRs';
export const GARAGE_COMPANY_LOGO = BASE_URL + '/api/vendor/uploadLogo';
export const ADD_GARAGE_SERVICES = BASE_URL + '/api/vendor/services';
export const CHANGE_COVER_IMAGE = BASE_URL + '/api/vendor/changeCover';
export const GET_REVIEWS_AND_RATINGS = BASE_URL + '/api/vendor/reviews';

/* Open jobs */
export const GET_OPEN_JOB_CATEGORIES = BASE_URL + '/api/job/list';


/*User Account APIs */
export const CHANGE_PASSWORD = BASE_URL + '/api/users/changepassword';
export const CONTACTDETAILSUPDATE = BASE_URL + '/api/users/contactdetails';
export const SENDOTP = BASE_URL + '/api/users/sendotp';
export const IMAGE_UPLOAD_REQUEST = BASE_URL + '/api/images/s3upload?file_name=';
export const NOTIFICATION_PREFERENCE_UPDATE = BASE_URL + '/api/vendor/notification/switch';
export const GET_USER_DETAIL_INFO = BASE_URL + '/api/vendor';
export const BUSINESS_TAX = BASE_URL + '/api/vendor/taxes';

/* Job Detailed View */
export const GET_POSTED_JOB = BASE_URL + '/api/job';
export const GET_JOB_SERVICE_STATUSES = BASE_URL + '/api/status/jobservicestatuses';
export const DECLINE_A_JOB = BASE_URL + '/api/job/${userbookingrequest-id}/decline';
export const UPDATE_JOB_STATUS = BASE_URL + '/api/job/${userbookingrequest-id}/updatesubservicestatus';
export const SEND_QUOTE = BASE_URL + '/api/job/sendquotes';
export const JOB_NOTES = BASE_URL + '/api/job/jobnotes';
export const SERVICED_KMS = BASE_URL + '/api/job/servicedatkms';
export const CONFIRM_PAYMENT = BASE_URL + '/api/job/confirmPayment';

/* Common */
export const GET_AUTO_SUGGESTED_LIST = BASE_URL + '/api/job/autosuggestlist';
export const SEARCH_JOBS = BASE_URL + '/api/job/search';
export const AUTO_ACCEPT_JOB = BASE_URL + '/api/vendor/autoacceptjob';
export const GET_JOB_COUNT = BASE_URL + '/api/job/statistics';
export const GET_CAR_MANUFACTURERS = BASE_URL + '/api/cars/manufacturers';
export const GET_CAR_MODELS = BASE_URL + '/api/cars/models';
export const GET_JOB_SCHEDULE = BASE_URL + '/api/job/schedulelist';
export const GET_OPEN_JOBS = BASE_URL + '/api/job/statistics';
export const GET_VENDOR_REVIEWS_AND_RATINGS = BASE_URL + '/api/vendor/reviews?garageId=';
export const UPDATE_COMMENTS_ON_REVIEW = BASE_URL + '/api/vendor/commentOnReview';
/* Notifications */
export const GET_NOTIFICATION_ALERTS = BASE_URL + '/api/notifications/alerts';
export const MARK_NOTIFICATION_AS_READ = BASE_URL + '/api/notifications/marknotificationasread/';
/* Dashboard */
export const GET_TOP_LOCATIONS = BASE_URL + '/api/job/toplocations';
export const GET_TOP_SERVICES = BASE_URL + '/api/job/topservices';
export const GET_JOB_FOR_TODAY = BASE_URL + '/api/job/jobfortheday';
export const GET_JOB_DISTRIBUTION_CHART = BASE_URL + '/api/job/jobdistribution';
export const GET_OVERVIEW = BASE_URL + '/api/vendor/overview';
export const DAILY_STATISTICS = BASE_URL + '/job/statistics/weekly';
export const WEEKLY_STATISTICS = BASE_URL + '/job/statistics/monthly';

/* Chat */
export const CREATE_CHAT_ROOM = BASE_URL + '/api/job/chatroom/create';
export const GET_ALL_CHATROOMS = BASE_URL + '/api/job/chatrooms/getAll';
export const GET_ALL_UNREAD_MESSAGES = BASE_URL + '/api/job/messages/unread';
export const GET_ALL_MESSAGE_OF_CHAT_ROOM = BASE_URL + '/api/job/${roomId}/messages';
/*Mangae User*/
export const GET_DRIVER_TYPES = BASE_URL + '/api/emergency/drivertypes';
export const ADD_USER = BASE_URL + '/api/emergency/adddriver';
export const GET_DRIVERS_LIST = BASE_URL + '/api/emergency/drivers';
export const EDIT_DRIVER_INFO = BASE_URL + '/api/emergency/driver/';
export const GET_VEHICLE_TYPES = BASE_URL + '/api/emergency/vehicletypes';
export const ADD_VEHICLE_INFO = BASE_URL + '/api/emergency/addvehicle';
export const GET_VEHICLE_LIST = BASE_URL + '/api/emergency/vehicles';
export const CRUD_VEHICLE = BASE_URL + '/api/emergency/vehicle/';

/* s3 Image upload */
export const S3_IMAGE_UPLOAD_SIGNED_REQUEST = BASE_URL + '/api/images/s3upload';
export const S3_IMAGE_UPLOAD_DONE = BASE_URL + '/api/images/s3upload/done';

/* Car Profile */
export const EDIT_CAR_PROFILES = BASE_URL + "/api/vehicles/";
export const GET_CAR_PROFILE_DETAILS = BASE_URL + "/api/vehicles/";

/*Driver Api*/
export const DRIVER_ONLINE_OFFLINE_MODE = BASE_URL + '/api/emergency/driver/updatestatus/';
export const GET_DRIVER_JOB_QUEUE = BASE_URL + '/api/emergency/driver/';
export const JOB_STATUS_CHANGE = BASE_URL + '/api/emergency/';
export const VEHICLE_HISTORY_QUEUE = BASE_URL + '/api/emergency/vehicle/';

export const APPLY_PROMOTIONAL_OFFERS = BASE_URL + "/api/offer/business/apply";



// WEBPACK FOOTER //
// ./src/constants/api.js